<template>
	<div class="phoneFooter" v-show="isHigh">
		<div class="phoneFooter_inner" v-for="(item,index) in navList" @click="chooseNav(index,item.route)"
			:key="index">
			<img :src="selectIndex == index?item.activePath:item.path" alt="">
			<p :class="selectIndex == index ?'pActive':''">{{item.label}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectIndex: 0,
				navList: [{
					label: '首页',
					path: require('../../../assets/img/phoneIndex/index.png'),
					activePath: require('../../../assets/img/phoneIndex/index1.png'),
					route: 'phoneIndex'
				}, {
					label: '服务',
					path: require('../../../assets/img/phoneIndex/service.png'),
					activePath: require('../../../assets/img/phoneIndex/service1.png'),
					route: 'phoneService'
				}, {
					label: '我的',
					path: require('../../../assets/img/phoneIndex/user.png'),
					activePath: require('../../../assets/img/phoneIndex/user1.png'),
					route: 'phoneMy'
				}],
				showHeight:0,
				isHigh:true,
				domHeight:0,
			}
		},
		watch: {
			'$route': function() {
				if (this.selectIndex != this.$route.meta.uid) {
					this.selectIndex = this.$route.meta.uid
				}
			},
			showHeight:'inputType'
		},
		mounted() {
			this.domHeight = window.innerHeight
			window.onresize = ()=>{
				return (()=>{
					this.showHeight = window.innerHeight
				})()
			}
		},
		methods: {
			inputType(){
				let height = this.showHeight * 0.2
				if(this.domHeight - this.showHeight <height){
					this.isHigh = true
				}else{
					this.isHigh = false
				}
			},
			chooseNav(index, name) {
				if (!this.$store.state.user.token && index > 0) {
					this.$message({
						showClose: true,
						message: '请先完成登录',
						type: 'warning'
					});
					this.selectIndex = 1
					this.$router.replace({
						name,
					})
				} else if (this.$store.state.user.userVip === false && index === 1) {
					this.$message({
						showClose: true,
						message: '非会员无法使用，请注册成为正式会员',
						type: 'warning'
					});
					this.selectIndex = 0
				} else {
					this.selectIndex = index
					this.$router.replace({
						name,
					})
				}
			}
		}
	}
</script>

<style scoped>
	.phoneFooter {
		width: 100%;
		height: 60px;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 989;
		background-color: #fff;
		display: flex;
		border-top: 1px solid #f5f5f5;
	}

	.phoneFooter_inner {
		flex: 1;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: center;
	}

	.phoneFooter_inner img {
		width: 25px;
		height: 25px;
	}

	.phoneFooter_inner p {
		margin-top: 5px;
		font-size: 14px;
	}

	.pActive {
		color: #c22c25;
	}
</style>
